import React from 'react'

const CustomerTableHeading = () => {
  return (
    <>
    <table width="100%" border="0" cellpadding="0" cellspacing="0" className='p-2.5 border border-slate bg-charcoal block lg:p-0 lg:border-none lg:bg-transparent lg:table'>
        <tbody>
            <tr align="center" className='hidden lg:table-row'>
                <th width="30" className='font-NotoSansKR h-[33px] text-center font-medium text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'>
                    <input type="checkbox" id="check_all" name="check_all" value="" className='text-xs text-white align-middle' />
                </th>
                <th width="70" height="24" className='font-NotoSansKR h-[33px] text-center font-medium text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'>번호</th>
                <th className='font-NotoSansKR h-[33px] text-center font-medium text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'>제목</th>
                <th width="126" align="left" className='font-NotoSansKR h-[33px] text-center font-medium text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;작성자</th>
                <th width="110" className='font-NotoSansKR h-[33px] text-center font-medium text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'>작성일시</th>
                <th width="70" className='font-NotoSansKR h-[33px] text-center font-medium text-[13px] text-white border-t-steel border-b-graphite border-b border-t-2 bg-graphite'>조회수</th>
            </tr>
        </tbody>
    </table>
</>
  )
}

export default CustomerTableHeading